export const MetricsMap = {
    CUSTOM_IMPRESSIONS: {
        value: 'custom_impressions',
        label: 'Impressions',
        shortLabel: 'Impr',
    },
    CUSTOM_CLICKS: {
        value: 'custom_clicks',
        label: 'Clicks',
    },
    CUSTOM_INSTALLS: {
        value: 'custom_installs',
        label: 'Installs',
    },
    COST: {
        value: 'adn_cost',
        label: 'Cost',
    },
    IPM: {
        value: 'ipm',
        label: 'IPM',
    },
    ECPM: {
        value: 'ecpm',
        label: 'eCPM',
    },
    ECPI: {
        value: 'ecpi',
        label: 'eCPI',
    },
    CTR: {
        value: 'ctr',
        label: 'CTR',
    },
    CVR: {
        value: 'cvr',
        label: 'CVR',
    },
    VIDEO_VIEWS: {
        value: 'video_views',
        label: 'Video Views',
        shortLabel: 'VV',
    },
    VIDEO_VIEWS_25PCT: {
        value: 'video_views_25pct',
        label: 'Video Views 25%',
        shortLabel: 'VV25',
    },
    VIDEO_VIEWS_50PCT: {
        value: 'video_views_50pct',
        label: 'Video Views 50%',
        shortLabel: 'VV50',
    },
    VIDEO_VIEWS_75PCT: {
        value: 'video_views_75pct',
        label: 'Video Views 75%',
        shortLabel: 'VV75',
    },
    COMPLETED_VIDEO_VIEWS: {
        value: 'completed_video_views',
        label: 'Completed Video Views',
        shortLabel: 'CVV',
    },
    COMPLETED_VIDEO_VIEW_RATE: {
        value: 'completed_video_view_rate',
        label: 'Completed Video View Rate',
        shortLabel: 'CVV-R',
    },
};

export const CREATIVES_CORE_METRICS_OPTIONS = Object.values(MetricsMap).map(({ value }) => value);

export const getAvailableMetricsOptions = (allUserMetrics, allRequestedMetrics) => {
    const allMetricNames = new Set(allUserMetrics.map(({ name }) => name));

    return allRequestedMetrics.filter(name => allMetricNames.has(name));
};

const getSortedMetrics = metrics => {
    const sortCallback = (a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase());

    return Array.prototype.toSorted ? metrics.toSorted(sortCallback) : [...metrics].sort(sortCallback);
};

export const getCohortFieldAndPeriod = field => {
    const fieldParts = field.split('_');
    if (fieldParts.length === 1) return [field, ''];
    const cohortPeriod = fieldParts[fieldParts.length - 1];
    const cohortMetric = fieldParts.slice(0, fieldParts.length - 1).join('_');

    return [cohortMetric, cohortPeriod];
};

export const ALL_METRICS_OPTIONS = Object.values(MetricsMap);
export const SORTED_METRICS_OPTIONS = getSortedMetrics(ALL_METRICS_OPTIONS);

export const createCohortOptions = (options, periods) =>
    options.reduce((acc, field) => {
        periods.forEach(period => {
            acc.push({
                value: `${field.name}_${period.name}`,
                label: `${field.display_name} ${period.name}`,
                display_format: field.display_format,
            });
        });

        return acc;
    }, []);

export const CohortGroupsToLabel = {
    Metrics: 'STATIC.COHORT_METRICS',
    ConversionEvents: 'STATIC.CONVERSION_EVENTS',
    CohortEvents: 'STATIC.COHORT_EVENTS',
    SpecialMetrics: 'STATIC.METRICS',
};
